<script>
import axios from 'axios';

export default {
  name: 'ProcedureDirectoryWidget',
  data() {
    return {
      procedureDirectories: [],
      pchartColors: ['#CFD8DC', '#C8E6C9', '#81C784', '#26a73a', '#EF5350', '#D32F2F'],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      axios.get('/procedureDirectory')
        .then((response) => {
          const tempProcedureDirectories = response.data;

          let openCount = 0;
          let inProgressCount = 0;
          let sendCount = 0;
          let approvedCount = 0;
          let approvedWithFlawCount = 0;
          let unapprovedFlawCount = 0;
          let inApprovalCount = 0;

          tempProcedureDirectories.forEach((it) => {
            const examState = it.examState ? it.examState.name.toLowerCase() : null;

            switch (examState) {
              case null:
              case 'offen': openCount += 1; break;
              case 'in bearbeitung': inProgressCount += 1; break;
              case 'versendet': sendCount += 1; break;
              case 'genehmigt': approvedCount += 1; break;
              case 'genehmigt mit mangel': approvedWithFlawCount += 1; break;
              case 'nicht genehmigt': unapprovedFlawCount += 1; break;
              case 'zur prüfung': inApprovalCount += 1; break;
              default: break;
            }
          });

          if (!(openCount || inProgressCount || sendCount || approvedWithFlawCount
          || unapprovedFlawCount || inApprovalCount)) {
            this.procedureDirectories = [];
          } else {
            this.procedureDirectories = [
              ['offen', openCount], ['in Bearbeitung', inProgressCount], ['versendet', sendCount], ['genehmigt', approvedCount],
              ['genehmigt mit Mangel', approvedWithFlawCount], ['nicht genehmigt', unapprovedFlawCount], ['zur Prüfung', inApprovalCount],
            ];
          }
        });
    },
    openProcedureDirectories() {
      this.$router.push('/procedureDirectories');
    },
  },
};
</script>

<template>
  <div>
    <v-card>
      <v-card-title
        class="cursor-pointer"
        @click="openProcedureDirectories">
        <v-icon large left>
          repeat
        </v-icon>
        <span class="title">Verfahren</span>
      </v-card-title>
      <pie-chart :colors="pchartColors" :data="procedureDirectories" />
    </v-card>
  </div>
</template>
